import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/Icon'
import { LANGUAGES, normalizeLanguage } from '@/i18n/languages'

export function LanguageSelect({ className = '' }: { className?: string }) {
  const { t, i18n } = useTranslation()
  const current = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language)
  return (
    <label className={`inline-flex items-center gap-2 text-ink-mute ${className}`}>
      <Icon name="globe" size={16} />
      <span className="sr-only">{t('shell.language')}</span>
      <select
        className="soc-field min-h-[34px] w-auto cursor-pointer py-1 pr-7 text-[13px]"
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        aria-label={t('shell.language')}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  )
}
